import { useEffect, useMemo, useState } from "react"
import { getSelectValuesByType } from "../../../../utils/app-utils"
import { Employee, SelectOption } from "../../../../services/dashboardService"
import { manualRequestsService } from "../../../../services/myActionsService"

const useAbsenceReasons = (selectedEmployee?: Employee) => {
  
  const absenceReasonTypeList = useMemo(
    () => getSelectValuesByType('AbsenceReasonType'),
    []
  )
  
  const absenceTypesList = useMemo(
    () => getSelectValuesByType('AbsenceType'),
    []
  )
  
  const [covidIndicator, setCovidIndicator] = useState<boolean>()
  const [absenceReason, setAbsenceReason] = useState<SelectOption>()
  const [absenceType, setAbsenceType] = useState<SelectOption>()
  const [employeeAbsenceTypesList, setEmployeeAbsenceTypesList] = useState<SelectOption[]>([])

  useEffect(() => {
    if (!selectedEmployee) {
      return
    }
    manualRequestsService
      .getAbsenceReasonsByEmployeeId(selectedEmployee.employeeId)
      .then(response => {
        setEmployeeAbsenceTypesList(response.locationAbsenceReasons.options)
      })
      .catch(err => {
        setEmployeeAbsenceTypesList([])
      })
  }, [selectedEmployee])

  return {
    absenceReason,
    setAbsenceReason,
    absenceType,
    setAbsenceType,
    absenceReasonTypeList,
    absenceTypesList,
    employeeAbsenceTypesList,
    covidIndicator,
    setCovidIndicator,
  }
}

export default useAbsenceReasons